import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {useLocation} from 'react-router-dom';

type AuthTeamSwitch = {
    teamId: string | null;
    tokenViewer: {
        teamIds: string[];
    };
    changeTeam: (teamId: string, options?: {redirectToHome?: boolean}) => void;
};

export default function useUrlTeamSwitch(auth: AuthTeamSwitch) {
    const location = useLocation();
    const queryClient = useQueryClient();
    const currentTeamFromUrl = new URLSearchParams(location.search).get('currentTeam');
    const shouldSwitchToUrlTeam = Boolean(
        currentTeamFromUrl &&
            currentTeamFromUrl !== auth.teamId &&
            auth.tokenViewer.teamIds.includes(currentTeamFromUrl)
    );

    useEffect(() => {
        if (!currentTeamFromUrl || !shouldSwitchToUrlTeam) return;

        queryClient.clear();
        auth.changeTeam(currentTeamFromUrl, {redirectToHome: false});
    }, [auth, currentTeamFromUrl, queryClient, shouldSwitchToUrlTeam]);

    return shouldSwitchToUrlTeam;
}
